import { render, staticRenderFns } from "./TaskDeleted.vue?vue&type=template&id=4d69b3c6&scoped=true"
import script from "./TaskDeleted.vue?vue&type=script&lang=js"
export * from "./TaskDeleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d69b3c6",
  null
  
)

export default component.exports